import { Button, Form, Input, Modal, Select } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { AddDesignationCategory, GetCategoryDesignationsById, GetDesignation, UpdateDesignationCategory, axiosErrorMessages } from "../../../API/api";
import axios, { AxiosError } from "axios";

interface AddEditCategoryType {
    isAdd:boolean;
    editDetails:any;
    handleCloseAddEdit: (data: boolean) => void;

  }

  const AddEditNewCategory: React.FC<AddEditCategoryType> = ({ isAdd,editDetails,handleCloseAddEdit }) => {
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [designationList,setDesignationList] = useState([])
    const [dropdownValues,setDropdownValues] = useState([])
    const [categoryDesignationList,setCategoryDesignationList] = useState([])
    const [designationValues,setDesignationValues] = useState([])
    const [addnewStatusForm] = Form.useForm();
    useEffect(() =>  {
      if(!isAdd)  {
        GetCategoryDesignationList()

      }
      fetchDesignationList()
     
    },[])
useEffect(()  =>  {
  setFormData()
},[dropdownValues])
    useEffect(()  =>  {
   if(isAdd)  {
    setDropdownValues(designationList)
   }else{
    if(categoryDesignationList.length > 0 && designationList.length>0)  {
      const newArray = [...categoryDesignationList ,... designationList]
      setDropdownValues(newArray)
   }
    
      }
    },[categoryDesignationList,designationList])
    const GetCategoryDesignationList = async () => {
      try {
        setIsLoading(true);
        const response = await GetCategoryDesignationsById(editDetails.categoryId);
        const newData = response.data.map((designation: any, index: number) => ({
          label: designation.designation,
          value: designation.designationId,
        }));

        const outputArray: any = newData.map((item:any) => item.value);

setDesignationValues(outputArray)
        setCategoryDesignationList(newData);
      } catch (error: any) {
        enqueueSnackbar(error, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      }
    };
    const fetchDesignationList = async () => {
      try {
        setIsLoading(true)
        const response = await GetDesignation();
        const newData = response.data.map((designation: any, index: number) => ({
          label: designation.designation,
          value: designation.designationId,
        }));

        setDesignationList(newData)
      } catch (error:any) {
        enqueueSnackbar(error, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      }
    }
    const setFormData = () => {
      const fpi:number[] = designationValues
      const filteredProjects = dropdownValues.filter(
        (project: { label: string; value: number }) => fpi.includes(project.value)
      );

      addnewStatusForm.setFieldsValue({
        categoryName:editDetails.categoryName,
        designationList: filteredProjects.map(
          (project: { label: string; value: number }) => project.value
        ),
       
      })
    }
    type FieldType = {
      categoryName?: string;
      designationList?: number[];
    };
    const handleCloseAddEditPopup = () => {setIsOpen(false); handleCloseAddEdit(true)}
    const filterOption = (
      input: string,
      option?: { label: string; value: number }
    ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

    const onSaveHandler = (formData:{categoryName:string,designationList:number[]}) =>{
        setIsLoading(true)
        if(formData.categoryName.trim())  {
          if(isAdd) {
            AddDesignationCategory(formData.categoryName.trim(),formData.designationList)
            .then((response:any)  =>  {
              enqueueSnackbar("Added Successfully", {
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              setIsOpen(false);
              handleCloseAddEdit(true)
              setIsLoading(false)
  
            })
            .catch((error:any)  =>  {
            
              enqueueSnackbar(error.response.data.errors.Category[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              setIsLoading(false)
  
            })
          }else {
            UpdateDesignationCategory(editDetails.categoryId,formData.categoryName.trim(),formData.designationList)
            .then((response:any)  =>  {
              enqueueSnackbar("Updated Successfully", {
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              setIsOpen(false);
              handleCloseAddEdit(true)
              setIsLoading(false)
  
            })
            .catch((error:any)  =>  {
            if(error.response.data.errors.Category[0])
              enqueueSnackbar(error.response.data.errors.Category[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              else  {
                let errorMsg;
                if (axios.isAxiosError(error)) {
                  const axiosError = error as AxiosError;
                  errorMsg = axiosErrorMessages(axiosError);
                } else {
                  errorMsg = error.message;
                }
                enqueueSnackbar(errorMsg, {
                  variant: "error",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                });
              }

              setIsLoading(false)
  
            })
          }
    
  
        }else
        enqueueSnackbar("Enter Values", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });


    }
    return (
        <div>
<Modal
              footer={null}
              title={isAdd ? 'Add Category':'Edit Category'}
              open={isOpen}
              onCancel={handleCloseAddEditPopup}
              maskClosable={false}
            >
                   <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onSaveHandler}
        autoComplete="off"
        form={addnewStatusForm}
      >
        <Form.Item<FieldType>
          label="Name"
          name="categoryName"
          rules={[{ required: true, message: "Enter Name" }]}
        >
          <Input maxLength={22} />
        </Form.Item>
        <Form.Item<FieldType>
          label="Designation"
          name="designationList"
          rules={[{ required: true, message: "Select Designation" }]}
        >
            <Select
            mode="multiple"
            maxTagCount="responsive"
            showSearch
            style={{ width: "100%" }}
            placeholder="Select Designation"
            options={dropdownValues}
            filterOption={filterOption}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
        </Form.Item>
      </Form>
            </Modal>


        </div>
    )
}
export default AddEditNewCategory;